"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _constants = require("../constants");

var useException = function useException() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var unmount = (0, _react.useRef)(false);
  var exception = (0, _react.useRef)({
    tryThrow: function tryThrow() {
      return null;
    }
  });

  exception.current.tryThrow = function () {
    if (unmount.current || args.some(function (f) {
      return f();
    })) {
      throw _constants.manualThrownError;
    }
  };

  (0, _react.useEffect)(function () {
    return function () {
      unmount.current = true;
    };
  }, []);
  return exception.current;
};

var _default = useException;
exports.default = _default;